const REMEMBER_ME_KEY = 'rememberMe';

function readCookie(name) {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(name, value, maxAgeSeconds) {
  if (typeof document === 'undefined') return;
  const parts = [
    `${name}=${encodeURIComponent(value)}`,
    'Path=/',
    'SameSite=Lax',
  ];
  if (typeof maxAgeSeconds === 'number') {
    parts.push(`Max-Age=${maxAgeSeconds}`);
  }
  document.cookie = parts.join('; ');
}

function expireCookie(name) {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax`;
}

/** Non-HttpOnly rememberMe flag (FE mirror; BE may also Set-Cookie). */
export function getRememberMeFromCookie() {
  const raw = readCookie(REMEMBER_ME_KEY);
  if (raw == null) return null;
  const v = String(raw).trim().toLowerCase();
  if (v === 'true' || v === '1') return true;
  if (v === 'false' || v === '0') return false;
  return null;
}

/**
 * Client-side rememberMe flag for UI / reload bootstrap.
 * BE sets HttpOnly refreshToken via Set-Cookie on login/refresh.
 */
export function setRememberMeCookie(rememberMe) {
  const maxAge = rememberMe ? 30 * 24 * 60 * 60 : 2 * 60 * 60;
  writeCookie(REMEMBER_ME_KEY, rememberMe ? 'true' : 'false', maxAge);
}

export function clearRememberMeCookie() {
  expireCookie(REMEMBER_ME_KEY);
}

/** Cookie wins; otherwise fall back to Redux rememberMe flag. */
export function isRememberMeEnabled(reduxFlag) {
  const cookie = getRememberMeFromCookie();
  if (cookie === true) return true;
  if (cookie === false) return false;
  return Boolean(reduxFlag);
}
